<div class="event-card-container">
  <div class="event-card">
    <button class="favorite-button" [class.favorited]="event?.isFavorite"
      (click)="toggleFavorite(event)"
      [matTooltip]="!event?.isFavorite ? ('event.add_to_favorite' | translate) : ('event.remove_from_favorite' | translate)">
      ★
    </button>
    @if (event?.event?.picture) {
      <img class="event-image" [src]="getEventImage(event.event.picture)">
    }
    <div class="event-content">
      <h3 class="event-title">{{event?.event?.title}}</h3>
      <div class="event-type" >
        <div [ngStyle]="{'background-color' : event?.event?.eventType?.color}" class="block"></div>
        <span [ngStyle]="{'border-bottom' : '2px solid ' + event?.event?.eventType?.color}" class="type-name">
          {{event?.event?.eventType?.name}}
        </span>
      </div>
      <p class="event-description" [innerHTML]="event?.event?.description"></p>
      <div class="event-organization">
        <img class="org-logo" [src]="getEventImage(event?.event?.organization?.logo)" >
        <span class="org-name">{{event?.event?.organization?.name}}</span>
      </div>
    </div>
    <div class="event-recommendation">
      <div class="recommender">
        @if (!event?.user?.logo) {
          <img class="recommender-avatar" src="assets/images/avatars/profile.jpg">
        }
        @if (event?.user?.logo) {
          <img class="recommender-avatar" [src]="getEventImage(event.user.logo)">
        }
        <div class="recommender-name">{{event?.user?.firstName}} {{event?.user?.lastName}}</div>
      </div>
      <div class="recommendation-text">{{event?.recommendation_text}}</div>
    </div>
    <div class="navigation">
      <button mat-raised-button class="mat-accent" (click)="subscriptionToEvent(event.event.id, index)">{{'main.subscription' | translate}}</button>
      <button mat-raised-button class="mat-accent" (click)="openDetail(event, index)">{{'event.event_detail' | translate}}</button>
    </div>
  </div>
</div>
